require('./vue');
require('./bootstrap');

if($('.datepicker').length) {
    require('./datepicker');
}

if ($('textarea.editor').length) {
    require('./tinymce');
}

require('./error_handling');
require('./main');